import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const Label = ({
  children,
  className,
  inputId,
  isOptional,
  isRequired,
  testSection,
  ...props
}) => {
  let classes = "";
  let fieldLabel = null;
  if (isRequired) {
    fieldLabel = /* @__PURE__ */ jsx("span", { className: "oui-label--required" });
  } else if (isOptional) {
    fieldLabel = /* @__PURE__ */ jsx("span", { className: "oui-label__optional", children: "(Optional)" });
  }
  if (typeof children === "string") {
    classes = "oui-label";
  }
  return /* @__PURE__ */ jsxs(
    "label",
    {
      className: classNames(classes, className),
      "data-oui-component": true,
      "data-test-section": testSection,
      htmlFor: inputId,
      ...props,
      children: [
        children,
        fieldLabel
      ]
    }
  );
};
Label.propTypes = {
  /** What the label describes */
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  /** CSS class names. */
  className: PropTypes.string,
  /** Id of the input to properly associate with this label */
  inputId: PropTypes.string,
  /** Includes optional label if true */
  isOptional: PropTypes.bool,
  /** Includes required asterisk label if true */
  isRequired: PropTypes.bool,
  /** Hook for automated JavaScript tests */
  testSection: PropTypes.string
};

export { Label as default };
